import { render, staticRenderFns } from "./BookingView.vue?vue&type=template&id=edab60c4"
import script from "./BookingView.vue?vue&type=script&lang=js"
export * from "./BookingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edab60c4')) {
      api.createRecord('edab60c4', component.options)
    } else {
      api.reload('edab60c4', component.options)
    }
    module.hot.accept("./BookingView.vue?vue&type=template&id=edab60c4", function () {
      api.rerender('edab60c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/booking/BookingView.vue"
export default component.exports